<div *ngIf="showLoadingOverLap" class="custom-overlap">
  <div (click)="goTo('wager')">
      <img src="/assets/splash.png" alt="amwager logo" class="tw-h-screen tw-w-screen">
      <!-- <p class="tw-text-[20px] tw-text-white tw-text-center">Loading...</p> -->
  </div>
</div>
<ion-app class="app-section">

  <!-- Live Video -->
  <!-- <div
    *ngIf="playLiveVideo && selectedEvent?.streamVideo"
    id="playLiveVideo"
    class="tw-absolute tw-bg-[#000000]"
  >
    <ng-container class="tw-relative">
      <ion-icon
        (click)="closeVideo()"
        *ngIf="selectedEvent?.streamVideo"
        class="close-video tw-text-[#FFFFFF] tw-text-[30px] tw-absolute tw-right-[0px]"
        name="close-outline"
      >
      </ion-icon>
      <iframe *ngIf="selectedEvent?.streamVideo"
        [src]="selectedEvent?.streamVideo | sanitizer"
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        allowfullscreen="true"
        allow="autoplay">
      </iframe>
    </ng-container>
  </div> -->

  <div *ngIf="betSummary" id="betSummary" class="bet-summary-content">
    <ul class="bet-summary-list">
      <li>
        <h6 data-cy="stacked-bets-text">
          Stacked Bets: $
          <span class="stack-today-sum" data-cy="stack-today-sum">
            {{ stackTodaySum | numberWithCommas }}
          </span>
        </h6>
      </li>
      <li>
        <h6 data-cy="bet-today-text">Bet Today: $
          <span class="bet-today-sum" data-cy="bet-today-sum">
            {{ betTodaySum | numberWithCommas }}
          </span>
        </h6>
      </li>
      <li>
        <h6 data-cy="won-today-text">Won Today: $
          <span class="won-today-sum" data-cy="won-today-sum">
            {{ wonTodaySum | numberWithCommas }}
          </span>
        </h6>
      </li>
      <li>
        <h6 data-cy="profit-loss-text">Profit/Loss: $
          <span class="profit-loss-sum" data-cy="profit-loss-sum">
            {{ profitLossSum | numberWithCommas }}
          </span>
        </h6>
      </li>
      <li>
        <h6 data-cy="active-bets-text">Active Bets: $
          <span class="active-bets-sum" data-cy="active-bets-sum">
            {{ activeBetsSum | numberWithCommas }}
          </span>
        </h6>
      </li>
      <li>
        <h6 data-cy="real-time-pl-text">Real Time P/L: $
          <span class="real-time-pl-sum" data-cy="real-time-pl-sum">
            {{ realTimePlSum | numberWithCommas }}
          </span>
      </h6>
      </li>
    </ul>
  </div>

  <!-- Main content -->
  <div class="ion-page" id="main-content">
    <ion-header *ngIf="isShowNavigation" class="header-section">
      <ion-toolbar class="header">
        <div class="head-content">
          <div
            class="
              tw-flex
              tw-justify-between
              tw-border-[#3472D6]
              tw-border-b-[1px]
              tw-pt-[0px]
              tw-pb-[2px]
              tw-pr-[15px]
              tw-pl-[15px]
            ">
            <ion-buttons slot="start">
              <ion-menu-button></ion-menu-button>

              <img
                #amwagerLogo
                src="assets/images/auth/amwager_logo_white.svg"
                id="companyLogo"
                class="company-logo tw-w-[88px] tw-mr-[4px]"
                alt="amwager logo white"
                data-cy="amwager-logo"
              />

              <div class="custom-toggle" data-cy="toggle-mode">
                <input type="checkbox" name="mode" id="mode" [class.checked]="darkMode"/>
                <label
                  (click)="toggleDarkMode()"
                  [class.dark-mode]="darkMode"
                  [class.justify-end]="darkMode"
                  for="mode"
                >
                  <span *ngIf="!darkMode" class="fade-in-out dark-mode tw-ml-[6px]">
                    <img src="assets/icons/moon_icon.png" width="20" alt="moon icon">
                  </span>
                  <span *ngIf="darkMode" class="fade-in-out tw-mr-[6px]">
                    <img src="assets/icons/sun_icon.png" width="20" alt="sun icon">
                  </span>
                </label>
              </div>

              <!-- For QA testing -->
              <ion-icon
                *ngIf="environment === 'development'"
                name="bug-sharp"
                class="bug-sharp-icon tw-mx-[10px] tw-text-[#FFFFFF]"
                (click)="isQAModalOpen=true;"
                data-cy="bug-sharp-icon">
              </ion-icon>

            </ion-buttons>

            <div slot="last">

              <div
                *ngIf="isAuthenticated"
                #amountBalance
                id="amountBalance"
                class="amount-balance tw-relative tw-inline-grid tw-center tw-mr-[11px]"
              >
                <span class="tw-text-[14px] tw-font-bold" data-cy="homescreen-balance-amount">
                  $ {{ (balance | numberWithCommas) || " 0" }}
                  <img
                    (click)="openFunding()"
                    class="add-amount"
                    src="assets/icons/money_plus_icon.png"
                    alt="money plus icon"
                    data-cy="homescreen-balance">
                </span>
              </div>

              <img
                *ngIf="isAuthenticated"
                (click)="openHistory()"
                src="assets/icons/history_icon.png"
                id="openHistory"
                class="open-history tw-inline tw-mr-[6px]"
                alt="history icon"
                data-cy="bet-summary"
              />

              <!-- *ngIf="isAuthenticated" -->
              <img
                *ngIf="isAuthenticated"
                (click)="openProfile()"
                id="open-account"
                src="assets/images/auth/account_user_icon.svg"
                class="tw-inline tw-p-2"
                alt="account user icon"
                data-cy="profile-icon"
              />

              <ion-button
                (click)="login()"
                *ngIf="!isAuthenticated"
                class="login-btn tw-capitalize tw-mr-[5px]"
                data-cy="homescreen-login-button">
                Login
              </ion-button>

              <ion-button
                (click)="goTo('signup')"
                *ngIf="!isAuthenticated"
                class="signup-btn tw-capitalize"
                data-cy="homescreen-signup-button">
                Sign Up
              </ion-button>
            </div>
          </div>

          <!-- <div class="
            wager-promos-balance
            tw-flex
            tw-items-center
            tw-pt-[8px]
            tw-pr-[15px]
            tw-pb-[11px]
            tw-pl-[15px]
          ">
            tw-mt-[8px] tw-mb-[7px]
            <img
              src="assets/images/auth/amwager_logo_white.svg"
              class="company-logo tw-w-[88px]"
              alt="amwager logo white"
              data-cy="amwager-logo">

            <div class="tw-flex tw-items-center tw-justify-end tw-w-full">
              <span class="promos tw-relative tw-text-[11px]" (click)="hasPermission()">
                <span class="count tw-bg-[#EB2A2A] tw-text-[#EB2A2A] tw-text-[11px]">1</span>
                <img
                  src="assets/icons/ticket_icon.svg"
                  class="ticket-icon tw-mt-[15px]"
                  alt="ticket icon">
                <span class="p-wording" data-cy="homescreen-promos">Promos</span>
              </span>
              (click)="hasPermission()"
              <div class="amount-balance tw-relative tw-center">
                <span class="tw-text-[20px] tw-font-bold" data-cy="homescreen-balance-amount">
                  $ {{ (balance | numberWithCommas) || " 0" }}
                  $ {{ isAuthenticated ? (balance | numberWithCommas) : ' ?' }}
                  <img
                    (click)="openFunding()"
                    class="add-amount"
                    src="assets/icons/money_plus_icon.png"
                    alt="money plus icon"
                    data-cy="homescreen-balance">
                </span>
              </div>
            </div>
          </div> -->

        </div>
      </ion-toolbar>
    </ion-header>

    <!-- Dynamic content -->
    <ion-content>
      <ion-router-outlet></ion-router-outlet>
    </ion-content>

    <input type="hidden" name="talon6" id="talon6" value='{"version": 6, "status": -1}'>
  </div>
</ion-app>



<!-- <ng-template #componentViewTemplate>
  <ion-app>
    <ion-router-outlet></ion-router-outlet>
  </ion-app>

</ng-template> -->

<!-- Live Video -->
<!-- <div *ngIf="playLiveVideo" id="playLiveVideo" class="tw-absolute tw-bg-[#000000]">
  <ng-container class="tw-relative">
    <ion-icon
      (click)="closeVideo()"
      *ngIf="selectedEvent?.streamVideo"
      class="close-video tw-text-[#FFFFFF] tw-text-[30px] tw-absolute tw-right-[0px]"
      name="close-outline"
    >
    </ion-icon>
    <iframe *ngIf="selectedEvent?.streamVideo"
      [src]="selectedEvent?.streamVideo | sanitizer"
      width="100%"
      height="100%"
      frameborder="0"
      scrolling="no"
      allowfullscreen="true"
      allow="autoplay">
    </iframe>
  </ng-container>
</div> -->

<!-- For QA testing -->
<ion-modal [isOpen]="isQAModalOpen">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Testing Purpose</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="isQAModalOpen=false;" data-cy="bug-close">Close</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-list>
        <ion-item>
          <ion-button
            (click)="qaReloadPage()"
            class="tw-capitalize tw-bg-blue-500 tw-text-white"
            data-cy="debug-reload-button">
            Reload app
          </ion-button>
        </ion-item>
        <ion-item>
          <ion-button
            (click)="qaMobileReport()"
            class="tw-capitalize tw-bg-blue-500 tw-text-white">
            QA mobile report
          </ion-button>
        </ion-item>
        <ion-item>
          <ion-toggle
            [enableOnOffLabels]="true"
            [checked]="qaTesting.showStatusCodeInToastMessage"
            (ionChange)="
              qaTestingFn({
                showStatusCodeInToastMessage: !qaTesting.showStatusCodeInToastMessage
              });
            "
            data-cy="bug-showStatusCodeInToastMessage-toggle">
            Show Status Code and Error Info
          </ion-toggle>
        </ion-item>
        <ion-item>
           <ion-button
            (click)="goTo('update-password')"
            class="tw-capitalize tw-bg-blue-500 tw-text-white"
            data-cy="updatepassword-button">
            Update Password (Click here to redirect page)
          </ion-button>
        </ion-item>
        <ion-item>
          <ion-accordion-group class="tw-w-full">
            <ion-accordion value="first">
              <ion-item slot="header" color="light">
                <ion-label>Wager: Use Custom Data</ion-label>
              </ion-item>
              <div class="ion-padding" slot="content">
                <div class="upload-container">
                  <label for="jsonFile">Select JSON file:</label>
                  <input
                    type="file"
                    id="jsonFile"
                    name="jsonFile"
                    (change)="qaTestingOnFileSelected($event)"
                  />
                </div>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </ion-item>
      </ion-list>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-toast
  [isOpen]="connectivity?.isOpen"
  [message]="connectivity?.message"
  class="custom-toast"
  swipe-gesture="vertical"
  [buttons]="[
    {
      text: 'close',
      role: 'cancel',
    },
  ]"
  (didDismiss)="onDidDismissToast()"
></ion-toast>
